import React, { useEffect, useState } from "react";
import Header from "../components/Header.js";
import Tarjeta from "../components/Tarjeta.js";

export default (props) => {
  const [vehiculos, setVehiculos] = useState([]);

  useEffect(() => {
    var url = "https://store.lenken.com.ar/lenkenapi/autos/" + props.modelo;

    fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((autos) => {
        console.log("here..", autos);
        setVehiculos(autos);

        const urltgm_base = "https://store.lenken.com.ar/vtf/urltgm/";

        //Solucion provisoria (Quitamos la barra que esta delante del modelo)
        let model = props.modelo.slice(1);

        let url_tgm = `${urltgm_base}modelo.php?modelo=${model}`;

        fetch(url_tgm);
      });
  }, [props.modelo]);

  const nombreModelorow = {
    background: "silver",
    height: "100px",
    fontFamily: "Audi Extended",
    fontSize: "70px",
    paddingLeft: "20px",
  };

  return (
    <div>
      <Header modelos={props.modelos} />
      <div className="row valign-wrapper" style={nombreModelorow}>
        {props.modelo.substring(1)}
      </div>
      <div className="row container">
        {vehiculos.map((auto) => {
          return (
            <Tarjeta
              key={auto.id}
              auto={auto}
              onSeleccionVehiculo={props.onSeleccionVehiculo}
              descuentos={props.descuentos}
            />
          );
        })}
      </div>
    </div>
  );
};
